import account_icon_select from '@/assets/home/dataEffect/account_icon_select.png'
import account_icon_unselect from '@/assets/home/dataEffect/account_icon_unselect.png'
import order_icon_select from '@/assets/home/dataEffect/order_icon_select.png'
import order_icon_unselect from '@/assets/home/dataEffect/order_icon_unselect.png'
import plan_icon_select from '@/assets/home/dataEffect/plan_icon_select.png'
import plan_icon_unselect from '@/assets/home/dataEffect/plan_icon_unselect.png'
import customer_icon_select from '@/assets/home/dataEffect/customer_icon_select.png'
import customer_icon_unselect from '@/assets/home/dataEffect/customer_icon_unselect.png'
import taobao_icon_select from '@/assets/home/goodsInfo/taobao_icon_select.png'
import taobao_icon_unselect from '@/assets/home/goodsInfo/taobao_icon_unselect.png'
import jd_icon_select from '@/assets/home/goodsInfo/jd_icon_select.png'
import jd_icon_unselect from '@/assets/home/goodsInfo/jd_icon_unselect.png'
import pinduoduo_icon_select from '@/assets/home/goodsInfo/pinduoduo_icon_select.png'
import pinduoduo_icon_unselect from '@/assets/home/goodsInfo/pinduoduo_icon_unselect.png'
import total_data_icon_select from '@/assets/home/overviewData/total_data_icon_select.png'
import total_data_icon_unselect from '@/assets/home/overviewData/total_data_icon_unselect.png'
import customer_manage_icon_select from '@/assets/home/userInfo/customer_manage_icon_select.png'
import customer_manage_icon_unselect from '@/assets/home/userInfo/customer_manage_icon_unselect.png'
import account_manage_icon_select from '@/assets/home/userInfo/account_manage_icon_select.png'
import account_manage_icon_unselect from '@/assets/home/userInfo/account_manage_icon_unselect.png'

export const userRoleDict = {
    admin: 1,
    operate: 2,
    data: 3
}

export const getTabList = () => {
    const userInfo = localStorage.userInfo ? JSON.parse(localStorage.userInfo) : {}
    if (userInfo.userRoleId === userRoleDict.admin) {
        return [
            {
                name: '数据总览',
                icon: total_data_icon_unselect,
                activeIcon: total_data_icon_select,
                router: "/overviewData/overviewData",
                isItem: true,
                children: [
                    {
                        name: '数据总览',
                        icon: total_data_icon_unselect,
                        activeIcon: total_data_icon_select,
                        router: "/overviewData/overviewData"
                    }
                ]
            },
            {
                name: '运营数据',
                icon: account_icon_unselect,
                activeIcon: account_icon_select,
                router: '/dataEffect',
                children: [
                    {
                        name: '账户级数据',
                        icon: account_icon_unselect,
                        activeIcon: account_icon_select,
                        router: "/dataEffect/accountData"
                    },
                    {
                        name: '计划级数据',
                        icon: plan_icon_unselect,
                        activeIcon: plan_icon_select,
                        router: "/dataEffect/planData"
                    },
                    {
                        name: '订单数据',
                        icon: order_icon_unselect,
                        activeIcon: order_icon_select,
                        router: "/dataEffect/orderData"
                    },
                    {
                        name: '客户数据',
                        icon: customer_icon_unselect,
                        activeIcon: customer_icon_select,
                        router: "/dataEffect/customerData"
                    }
                ]
            },
            {
                name: '商品信息',
                router: '/goodsInfo',
                icon: order_icon_unselect,
                activeIcon: order_icon_select,
                children: [
                    // {
                    // 	name: '商品列表',
                    // 	icon: commodity_icon_unselect,
                    // 	activeIcon: commodity_icon_select,
                    // 	router: "/goodsInfo/goodsList"
                    // },
                    {
                        name: '淘宝商品管理',
                        icon: taobao_icon_unselect,
                        activeIcon: taobao_icon_select,
                        router: "/goodsInfo/taobao"
                    },
                    {
                        name: '京东商品管理',
                        icon: jd_icon_unselect,
                        activeIcon: jd_icon_select,
                        router: "/goodsInfo/jd"
                    },
                    {
                        name: '拼多多商品管理',
                        icon: pinduoduo_icon_unselect,
                        activeIcon: pinduoduo_icon_select,
                        router: "/goodsInfo/pdd"
                    }
                ]
            },
            {
                name: '推广',
                router: '/promotion',
                icon: order_icon_unselect,
                activeIcon: order_icon_select,
                children: [
                    {
                        name: '批量创建',
                        icon: taobao_icon_unselect,
                        activeIcon: taobao_icon_select,
                        router: "/promotion/createBatch"
                    },
                ]
            },
            {
                name: '工具',
                router: '/tool',
                icon: order_icon_unselect,
                activeIcon: order_icon_select,
                children: [
                    {
                        name: '标题库',
                        icon: taobao_icon_unselect,
                        activeIcon: taobao_icon_select,
                        router: "/tool/title"
                    },
                ]
            },
            {
                name: '用户信息',
                router: '/userInfo',
                icon: customer_manage_icon_unselect,
                activeIcon: customer_manage_icon_select,
                children: [
                    {
                        name: '客户管理',
                        icon: customer_manage_icon_unselect,
                        activeIcon: customer_manage_icon_select,
                        router: "/userInfo/customerManage"
                    },
                    {
                        name: '账号管理',
                        icon: account_manage_icon_unselect,
                        activeIcon: account_manage_icon_select,
                        router: "/userInfo/accountManage"
                    }
                ]
            },
        ]
    } else {
        return [
            {
                name: '数据总览',
                router: '/overviewData/overviewData',
                isItem: true,
                icon: total_data_icon_unselect,
                activeIcon: total_data_icon_select,
                children: [
                    {
                        name: '数据总览',
                        icon: total_data_icon_unselect,
                        activeIcon: total_data_icon_select,
                        router: "/overviewData/overviewData"
                    }
                ]
            },
            {
                name: '运营数据',
                router: '/dataEffect',
                icon: account_icon_unselect,
                activeIcon: account_icon_select,
                children: [
                    {
                        name: '账户级数据',
                        icon: account_icon_unselect,
                        activeIcon: account_icon_select,
                        router: "/dataEffect/accountData"
                    },
                    {
                        name: '计划级数据',
                        icon: plan_icon_unselect,
                        activeIcon: plan_icon_select,
                        router: "/dataEffect/planData"
                    },
                    {
                        name: '订单数据',
                        icon: order_icon_unselect,
                        activeIcon: order_icon_select,
                        router: "/dataEffect/orderData"
                    }
                ]
            },
            {
                name: '商品信息',
                router: '/goodsInfo',
                icon: order_icon_unselect,
                activeIcon: order_icon_select,
                children: [
                    // {
                    // 	name: '商品列表',
                    // 	icon: commodity_icon_unselect,
                    // 	activeIcon: commodity_icon_select,
                    // 	router: "/goodsInfo/goodsList"
                    // },
                    {
                        name: '淘宝商品管理',
                        icon: taobao_icon_unselect,
                        activeIcon: taobao_icon_select,
                        router: "/goodsInfo/taobao"
                    },
                    {
                        name: '京东商品管理',
                        icon: jd_icon_unselect,
                        activeIcon: jd_icon_select,
                        router: "/goodsInfo/jd"
                    },
                    {
                        name: '拼多多商品管理',
                        icon: pinduoduo_icon_unselect,
                        activeIcon: pinduoduo_icon_select,
                        router: "/goodsInfo/pdd"
                    }
                ]
            },
        ]
    }
}


export const sortDict = {
    ascending: 'asc',
    descending: 'desc',
    asc: 'ascending',
    desc: 'descending'
}


export const totalToColMap = [
    {
        to: 'orderNum',
        from: 'customerOrderNum'
    },
    {
        to: 'orderReturnNum',
        from: 'customerOrderReturnNum'
    },
    {
        to: 'orderReturnTotalPrice',
        from: 'customerOrderReturnTotalPrice'
    },
    {
        to: 'orderValidEstimateCosPrice',
        from: 'customerOrderValidEstimateCosPrice'
    },
    {
        to: 'orderValidNum',
        from: 'customerOrderValidNum'
    },
    //
    {
        to: 'totalSaleRoi',
        from: 'customerTotalSaleRoi'
    },
    {
        to: 'roi',
        from: 'customerRoi'
    },
    {
        to: 'orderValidTotalSalePrice',
        from: 'customerOrderValidTotalSalePrice'
    }
]



// WEBPACK FOOTER //
// ./src/pages/home/config.js